import { createFileRoute } from "@tanstack/react-router";
import { WritingStylePage } from "@client/components/writing-style/writing-style-page";

export const Route = createFileRoute("/_app/doc-generation/writing-style")({
  component: WritingStylePage,
});
